import { Reveal } from "./Reveal";

const STORY_IMG =
  "https://customer-assets-4nw71qhi.emergentagent.net/job_covenant-coaching/artifacts/qra8trcv__K1A0789.webp";

export const Story = () => (
  <section id="story" className="py-24 lg:py-32 bg-[#F3EFEA]/50" data-testid="story-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <div className="grid grid-cols-12 gap-8 items-center">
        <Reveal className="col-span-12 lg:col-span-6 relative z-0">
          <div className="rounded-3xl overflow-hidden shadow-[0_8px_30px_rgb(0,0,0,0.06)]">
            <img
              src={STORY_IMG}
              alt="Denise and Richard Wicks together"
              className="w-full h-[420px] lg:h-[540px] object-cover"
              data-testid="story-image"
            />
          </div>
        </Reveal>

        <div className="col-span-12 lg:col-span-6 relative z-10 lg:-ml-16 mt-[-60px] lg:mt-0">
          <Reveal delay={0.15}>
            <div className="bg-[#FAF9F6] rounded-3xl p-10 lg:p-14 border border-black/5 shadow-[0_8px_30px_rgb(0,0,0,0.05)]">
              <p className="text-xs uppercase tracking-[0.25em] text-[#8A5A44] mb-4">02 — Our story</p>
              <h2 className="font-serif-display text-4xl sm:text-5xl font-medium tracking-tight text-[#2C2A28]">
                41 years. Separated.
                <br />
                Remarried. <em className="italic text-[#8A5A44]">Still standing.</em>
              </h2>
              <div className="mt-8 space-y-5 text-[#5C5854] leading-relaxed font-light">
                <p>
                  Denise and Richard Wicks aren't perfect — and they'll be the first to tell you.
                  In four decades of marriage they've walked through it all, including a separation
                  that could have been the end. Instead, by keeping God at the center and choosing
                  each other again, it became the beginning of something deeper.
                </p>
                <p>
                  People have always found their way to them — at church, at the kitchen table, over
                  the phone — yearning for honest, godly guidance in their relationships. No
                  lectures. No judgment. Just straight talk from two people who've lived it.
                </p>
                <p>
                  This ministry makes official what they've done naturally for years: helping
                  couples build marriages centered on family, legacy, and a divine union with God.
                </p>
              </div>
              <p className="font-serif-display italic text-xl text-[#8A5A44] mt-10" data-testid="story-scripture">
                "A cord of three strands is not quickly broken." — Ecclesiastes 4:12
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
